import { useEffect, useState } from "react";

export function useCompactHeader(selector, deps = []) {
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    // Solo aplica en pantallas móviles
    if (window.innerWidth > 768) return;

    const container = document.querySelector(selector);
    if (!container) return;

    const handleScroll = () => {
      const scrollTop = container.scrollTop || 0;
      setIsCompact(scrollTop > 40);
    };

    container.addEventListener("scroll", handleScroll);

    // Limpieza
    return () => container.removeEventListener("scroll", handleScroll);
  }, [selector, ...deps]);

  return isCompact;
}
